import { Query } from '../../../../hooks/queries'
import { useContrastQuery } from '../../../../hooks/use-contrast-query'
import {
  getTestBugtracker,
  GetTestBugtrackerArgs,
  GetTestBugtrackerResponse
} from './requests/get-test-bugtracker'
import { BugtrackerRequest } from './shared'
import { buildApiPayloadBugtrackerCredentials } from './build-api-payload-bugtracker-credentials'

export interface TestBugtrackerQueryProps {
  organizationUuid: string
  bugtrackerId?: number
  bugtrackerType: 'jira' | 'vsts' | 'github' | 'agilecentral'
  bugtrackerRequest: BugtrackerRequest | null
  disableQuery?: boolean
  successCallback: () => void
  errorCallback: (error) => any
}

export interface TestBugtrackerQueryResponse {
  result?: GetTestBugtrackerResponse
  error: Error | null
  isError: boolean
  isLoading: boolean
}

export type TestBugtrackerQueryQuery = (
  props: TestBugtrackerQueryProps
) => TestBugtrackerQueryResponse

export const useTestBugtrackerQuery: TestBugtrackerQueryQuery = ({
  organizationUuid,
  bugtrackerId,
  bugtrackerRequest,
  bugtrackerType,
  disableQuery = false,
  successCallback,
  errorCallback
}: TestBugtrackerQueryProps) => {
  const {
    data: result,
    error,
    isError,
    isLoading
  } = useContrastQuery<GetTestBugtrackerArgs, GetTestBugtrackerResponse>(
    [
      Query.INTEGRATIONS_TEST_BUGTRACKER,
      organizationUuid,
      bugtrackerType,
      bugtrackerId,
      bugtrackerRequest
    ],
    getTestBugtracker,
    {
      organizationUuid,
      bugtrackerRequest,
      bugtracker: bugtrackerType
    },
    {
      enabled:
        !!buildApiPayloadBugtrackerCredentials(bugtrackerRequest) &&
        !disableQuery,
      cacheTime: 0,
      onSuccess: successCallback,
      onError: errorCallback
    }
  )

  return {
    result,
    error,
    isError,
    isLoading
  }
}
